import React, { createContext, useEffect, useState } from "react";

import { PropsType } from "../../interfaces/ChildrenType";
import { PaymentSelectedContextType } from "./payment-selected-types";

const PaymentSelectedData = sessionStorage.getItem("pepper-user-payment-selected");
const CoPaymentSelectedData = sessionStorage.getItem("pepper-user-co-payment-selected");

const initialState: PaymentSelectedContextType = {
  paymentSelected: JSON.parse(PaymentSelectedData as string) || undefined,
  coPaymentSelected: JSON.parse(CoPaymentSelectedData as string) || undefined,
  setPaymentSelected: () => { },
  setCoPaymentSelected: () => { }
};

export const PaymentSelectedContext = createContext(initialState);

export const PaymentSelectedContextProvider: React.FC<PropsType> = ({
  children
}) => {
  const [paymentSelected, setPaymentSelected] = useState<
  any | undefined
  >(initialState.paymentSelected);
  const [coPaymentSelected, setCoPaymentSelected] = useState<
  any | undefined
  >(initialState.coPaymentSelected);

  useEffect(() => {
    if (paymentSelected) {
      sessionStorage.setItem('pepper-user-payment-selected', JSON.stringify(paymentSelected))
    } else {
      sessionStorage.removeItem("pepper-user-payment-selected");
    }
  }, [paymentSelected]);

  useEffect(() => {
    if (coPaymentSelected) {
      sessionStorage.setItem('pepper-user-co-payment-selected', JSON.stringify(coPaymentSelected))
    } else {
      sessionStorage.removeItem("pepper-user-co-payment-selected");
    }
  }, [coPaymentSelected]);

  return (
    <PaymentSelectedContext.Provider
      value={{ paymentSelected, setPaymentSelected, coPaymentSelected, setCoPaymentSelected }}
    >
      {children}
    </PaymentSelectedContext.Provider>
  );
};
